var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"class",attrs:{"type":"submit"}},[(_vm.loading)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('span',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }